import actions from './actions'
import { setTicketSearchHistory } from 'tickets/utils/localStorage'
import {
  getSearchOrigin,
  getSearchDestination,
  getSearchOutboundDateTime,
  getSearchInboundDateTime,
  getSearchPax,
} from 'tickets/redux/modules/router/selectors'

const updateOriginKind = actions.updateOriginKind
const updateDestinationKind = actions.updateDestinationKind
const updateOriginLatLng = actions.updateOriginLatLng
const updateDestinationLatLng = actions.updateDestinationLatLng

const saveSearchHistory = () => (dispatch, getState) => {
  const state = getState()

  const ticketSearch = {
    origin: {
      canonical: getSearchOrigin(state),
    },
    destination: {
      canonical: getSearchDestination(state),
    },
    oDateTime: getSearchOutboundDateTime(state),
    iDateTime: getSearchInboundDateTime(state),
    pax: [...getSearchPax(state)],
  }

  setTicketSearchHistory(ticketSearch)
}

  // Save the mode from the URL on intial page load
  // Needed to log failed handovers from map/ landing pages etc
  const updateHandoverMode = actions.updateHandoverMode

export default {
  updateOriginKind,
  updateDestinationKind,
  saveSearchHistory,
  updateOriginLatLng,
  updateDestinationLatLng,
  updateHandoverMode,
}
